import React from 'react';
import ReactDOM from 'react-dom';

import { smoothScroll } from './app/ui';
import { callMeFormSubmit } from './components/ForRestaurants/CallMeForm';
import OnlineOrdersOffer from './containers/for-restaurants/OnlineOrdersOffer';
import ForRestaurantsSpecialOffer from './containers/for-restaurants/SpecialOffer';
import SubscriptionOffer from './containers/for-restaurants/SubscriptionOffer';
import LubJeAddRestaurant from './containers/for-restaurants/LubJeAddRestaurant';
import ReservationsOffer from './containers/for-restaurants/ReservationsOffer';

const contactForm = document.querySelector('.fr-form')
contactForm && contactForm.addEventListener('submit', callMeFormSubmit);

const offerContainersAndPages = [
  {
    containerId: 'reseravations-offer-container',
    component: ReservationsOffer,
  },
  {
    containerId: 'online-orders-offer-container',
    component: OnlineOrdersOffer
  },
  {
    containerId: 'special-offer-container',
    component: ForRestaurantsSpecialOffer
  },
  {
    containerId: 'subscription-offer-container',
    component: SubscriptionOffer
  },
  {
    containerId: 'lubje-add-restaurant-offer-container',
    component: LubJeAddRestaurant,
  }
]

if (process.env.NODE_ENV !== 'test') {
  offerContainersAndPages.forEach(item => {
    const container = document.getElementById(item.containerId);
    container && ReactDOM.render(<item.component />, container);
  });
  smoothScroll();
}
